import React, { useState, useEffect } from 'react';
import { locationsAPI } from '../../services/api';
import './LocationSelector.scss';

const LocationSelector = ({ onLocationSelect, selectedLocation }) => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchLocations();
  }, []);

  const fetchLocations = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await locationsAPI.getAll();
      setLocations(response.data || []);
    } catch (err) {
      setError('Failed to load locations');
      console.error('Error fetching locations:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleLocationClick = (location) => {
    onLocationSelect(location);
  };

  if (loading) {
    return (
      <div className="location-selector">
        <div className="loading-state">Loading locations...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="location-selector">
        <div className="error-state">{error}</div>
      </div>
    );
  }

  return (
    <div className="location-selector">
      <h2>Select a Location</h2>
      <p className="subtitle">Choose your preferred clinic location</p>
      
      <div className="locations-grid">
        {locations.map((location) => (
          <div
            key={location._id}
            className={`location-card ${selectedLocation?._id === location._id ? 'selected' : ''}`}
            onClick={() => handleLocationClick(location)}
          >
            <div className="location-header">
              <h3>{location.name}</h3>
            </div>
            {location.mapEmbedUrl && (
              <div className="location-map">
                <iframe
                  src={location.mapEmbedUrl}
                  width="100%"
                  height="200"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title={location.name}
                />
              </div>
            )}
            <div className="location-details">
              {location.address.fullAddress && (
                <p className="address">
                  <span className="icon">📍</span>
                  {location.address.fullAddress}
                </p>
              )}
              {location.phone && (
                <p className="phone">
                  <span className="icon">📞</span>
                  {location.phone}
                </p>
              )}
              {location.email && (
                <p className="email">
                  <span className="icon">✉️</span>
                  {location.email}
                </p>
              )}
            </div>
            <div className="location-footer">
              <span className="select-indicator">
                {selectedLocation?._id === location._id ? '✓ Selected' : 'Select'}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LocationSelector;
